import { render, staticRenderFns } from "./InspectionViewAssessment.vue?vue&type=template&id=bb11910c"
import script from "./InspectionViewAssessment.vue?vue&type=script&lang=js"
export * from "./InspectionViewAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports